var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"has-text-weight-bold",class:( _obj = { 'matrix-column-button': !_vm.isOn }, _obj[_vm.code.code] = true, _obj ),attrs:{"title":_vm.title,"type":_vm.isOn ? 'is-dark' : '',"disabled":_vm.disabled,"loading":_vm.toggling},on:{"click":_vm.toggle_}},[_vm._v("\n  "+_vm._s(_vm.code.code)+"\n")])
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1246afb2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/CodesMatrixManager/partials/matrixColumn.vue
// module id = null
// module chunks = 